import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'opac-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @HostBinding('class.primary')
  get hostBindingPrimaryClass() {
    return this.primary;
  }

  /**
   * Determines if badge should have primary accent
   */
  @Input() primary: boolean = false;
}
